import { CartService } from "@modules/cart/services/CartService";
import CartListenerInterface from "@modules/cart/utils/CartListener/CartListenerInterface";
import ReferrerProviderInterface from "@modules/common_module/ReferrerProvider/ReferrerProviderInterface";
import { TrackingApiServiceInterface } from "@modules/legacy_tracking/services/TrackingApiServiceInterface";
import { combineLatest, from, lastValueFrom, of } from "rxjs";
import { switchMap } from "rxjs/operators";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { INSTAGRAM_TRACKING_APP_NAME } from "../constants";

class InstagramAddToCartTracker {
    constructor(
        private readonly logger: LoggerInterface,
        private readonly cartListener: CartListenerInterface,
        private readonly cartService: CartService,
        private readonly referrerProvider: ReferrerProviderInterface,
        private readonly trackersService: TrackingApiServiceInterface
    ) {}

    track() {
        this.logger.debug("InstagramAddToCartTracker.track start traking");
        this.cartListener
            .listen()
            .pipe(
                switchMap((event) =>
                    combineLatest([of(event), from(this.cartService.getCart())])
                )
            )
            .subscribe(([addToCartEvent, cart]) => {
                this.logger.debug(
                    "InstagramAddToCartTracker new addToCartEvent",
                    {
                        addToCartEvent,
                        cart,
                    }
                );

                const referrer = this.referrerProvider.getReferrer();
                if (referrer) {
                    void lastValueFrom(
                        this.trackersService.trackAddToCart({
                            cartToken: cart.token,
                            variantId: addToCartEvent.variantId,
                            appName: INSTAGRAM_TRACKING_APP_NAME,
                            cartReferrer: referrer,
                        })
                    );
                }
            });
    }
}

export default InstagramAddToCartTracker;
